module.exports = __webpack_public_path__ + "static/img/hotelface.48e871a.png";


//////////////////
// WEBPACK FOOTER
// ./static/Brand/BrandDf/hotelface.png
// module id = 1122
// module chunks = 18